import React from "react";

/**
 * InfraYield "IY" mark — slanted composition.
 * The "I" is a vertical bar; the "Y" is two converging strokes that meet
 * at a midpoint and continue down as a single stem. Rendered as a flat
 * SVG so it stays crisp on the favicon and in headers.
 */
const IY_PATHS = (
  <g transform="translate(20 20) rotate(12) translate(-20 -20)">
    {/* I — vertical bar */}
    <rect x="11" y="9" width="3.6" height="22" rx="0.8" fill="#07111F" />
    {/* Y — left diagonal into junction */}
    <path d="M17.4 10 L24.2 20" stroke="#07111F" strokeWidth="3.6" strokeLinecap="round" />
    {/* Y — right diagonal into junction */}
    <path d="M31 10 L24.2 20" stroke="#07111F" strokeWidth="3.6" strokeLinecap="round" />
    {/* Y — vertical stem from junction down */}
    <path d="M24.2 20 L24.2 31" stroke="#07111F" strokeWidth="3.6" strokeLinecap="round" />
  </g>
);

export function LogoMark({ size = 40, className = "" }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-label="InfraYield"
      role="img"
      className={className}
    >
      <defs>
        <linearGradient id={`iy-mark-${size}`} x1="0" y1="0" x2="40" y2="40" gradientUnits="userSpaceOnUse">
          <stop offset="0" stopColor="#22C55E" />
          <stop offset="1" stopColor="#15803D" />
        </linearGradient>
      </defs>
      <rect x="0" y="0" width="40" height="40" rx="9" fill={`url(#iy-mark-${size})`} />
      {IY_PATHS}
    </svg>
  );
}

export default function Logo({ size = 28, className = "" }) {
  return (
    <span
      className={"inline-flex items-center gap-2.5 " + className}
      data-testid="brand-logo"
    >
      <svg
        width={size}
        height={size}
        viewBox="0 0 40 40"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-label="InfraYield"
        role="img"
      >
        <defs>
          <linearGradient id="iy-tile" x1="0" y1="0" x2="40" y2="40" gradientUnits="userSpaceOnUse">
            <stop offset="0" stopColor="#22C55E" />
            <stop offset="1" stopColor="#15803D" />
          </linearGradient>
        </defs>
        <rect x="0" y="0" width="40" height="40" rx="9" fill="url(#iy-tile)" />
        {IY_PATHS}
      </svg>
      <span className="font-display text-lg font-bold tracking-tight text-[#F8FAFC]">
        InfraYield
        <span className="ml-0.5 font-body text-xs font-medium text-[#38BDF8]">.co</span>
      </span>
    </span>
  );
}
